import { render } from "./updatePass.vue?vue&type=template&id=1fb718d2&scoped=true"
import script from "./updatePass.vue?vue&type=script&lang=js"
export * from "./updatePass.vue?vue&type=script&lang=js"

import "./updatePass.vue?vue&type=style&index=0&id=1fb718d2&lang=less&scoped=true"

import exportComponent from "/Users/wangdadan/IdeaProjects/LTCODE/后端管理web端/rent-admin-web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.25_vue@3.5.25_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb718d2"]])

export default __exports__